<template>
  <div class="player">
    <p class="title">이달의 선수</p>
    <div class="swiper" v-if="playerStatus">
      <swiper ref="playerSwiper" :options="swiperOption" class="mySwiper">
        <swiper-slide
          v-for="(item, index) in list"
          :key="index"
          class="slide">
          <div class="item">
            <img class="bg" :src="item.player_img" :alt="item.k_name">
            <div class="playerBox">
              <ul>
                <li class="num">
                  <p>{{item.player_no}}</p>
                </li>
                <li class="info">
                  <p class="team">{{item.k_name}}</p>
                  <p class="position">{{item.position}}</p>
                </li>
              </ul>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div v-else class="noData">
      준비중입니다
    </div>
  </div>
</template>

<script>
import {Swiper, SwiperSlide} from 'vue-awesome-swiper';
import 'swiper/css/swiper.css'
import dayjs from 'dayjs';

export default {
  name : 'Player',
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 1.2,
        spaceBetween: 16,
        centeredSlides: true,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        breakpoints: {
          '960': {
            spaceBetween: 20,
            slidesPerView: 2,
          },

        }
      },
      swiperPause: false,
      list: [],
      playerStatus: false,
      year: dayjs().get('year'),
      month: dayjs().get('month') + 1
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      const {data} = await this.$http.get(`/player/month?year=${this.year}&month=${this.month}`)
      // const {data} = await this.$http.get('/player/month')
      if (data.success) {
        // this.playerStatus = true // 임시 true
        data.data.map(item => {
          // 임시 주석처리
          if(item.player_id) {
            item.player_img = 'https://www.dragons.co.kr/' + item.player_img; // 임시 이미지 경로 고정
            // item.player_img = 'https://www.dragons.co.kr/resource/images/player/2023/20230300.png'; // 임시 이미지 경로 고정
            // item.position = 'FW';
            // item.k_name = '임시'
            this.list.push(item);
          }
        })

        if(this.list.length > 0) {
          this.playerStatus = true
        }
      }
    }
  }
}
</script>
<style scoped>
  .noData {
    text-align: center;
    padding: 20px;
    font-size: 14px;
    color: #999;
  }
</style>
